export default __webpack_public_path__ + "static/logos/google-g-logo-d7f092af888a54de79ed9c9303d689d7.svg";